module.exports = __webpack_public_path__ + "img/lumax_big.4a98473f.jpg";